// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commingSoonCon{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2rem;
}

.commingSoonBox{
    border: 2px solid #FFFFFF;
    background: #FFFFFF33;
    box-shadow: 2px 2px 10px 0px #00000024;
    padding: 2rem;
    margin: 2rem;
    min-width: 37.5rem;
    min-height: 20rem;
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
}

.commingSoonBox > h1{
    font-size: 60px;
    font-weight: 700;
    text-align: center;
    color: #000000;
}
.commingSoonBox > p{
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    color: #717171;
    text-align: center;
    margin: 0;
}
.commingSoonBox > a{
  text-decoration: none;
}


@media screen and (max-width: 760px){

    .commingSoonBox{
        min-width: 0px!important;
    }


    .commingSoonBox > h1{
        font-size: 40px;
        font-weight: 700;
        text-align: center;
        color: #000000;
    }
    .commingSoonBox > p{
        font-size: 20px;
        font-weight: 500;
        text-align: center;
        color: #717171;
        text-align: center;
        margin: 0;
    }
    .commingSoonBox > a{
      text-decoration: none;
    }
    
}


@media screen and (max-width: 600px){

     .commingSoonBox > h1{
        font-size: 35px;
        white-space: nowrap;
        font-weight: 700;
        text-align: center;
        color: #000000;
    }
    .commingSoonBox > p{
        font-size: 18px;
        font-weight: 500;
        text-align: center;
        color: #717171;
        text-align: center;
        margin: 0;
    }
    .commingSoonBox > a{
      text-decoration: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/CommingSoon/Index.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,sCAAsC;IACtC,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,SAAS;AACb;AACA;EACE,qBAAqB;AACvB;;;AAGA;;IAEI;QACI,wBAAwB;IAC5B;;;IAGA;QACI,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,cAAc;IAClB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,cAAc;QACd,kBAAkB;QAClB,SAAS;IACb;IACA;MACE,qBAAqB;IACvB;;AAEJ;;;AAGA;;KAEK;QACG,eAAe;QACf,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,cAAc;IAClB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,cAAc;QACd,kBAAkB;QAClB,SAAS;IACb;IACA;MACE,qBAAqB;IACvB;AACJ","sourcesContent":[".commingSoonCon{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 2rem;\n}\n\n.commingSoonBox{\n    border: 2px solid #FFFFFF;\n    background: #FFFFFF33;\n    box-shadow: 2px 2px 10px 0px #00000024;\n    padding: 2rem;\n    margin: 2rem;\n    min-width: 37.5rem;\n    min-height: 20rem;\n    width: 80%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10px;\n}\n\n.commingSoonBox > h1{\n    font-size: 60px;\n    font-weight: 700;\n    text-align: center;\n    color: #000000;\n}\n.commingSoonBox > p{\n    font-size: 24px;\n    font-weight: 500;\n    text-align: center;\n    color: #717171;\n    text-align: center;\n    margin: 0;\n}\n.commingSoonBox > a{\n  text-decoration: none;\n}\n\n\n@media screen and (max-width: 760px){\n\n    .commingSoonBox{\n        min-width: 0px!important;\n    }\n\n\n    .commingSoonBox > h1{\n        font-size: 40px;\n        font-weight: 700;\n        text-align: center;\n        color: #000000;\n    }\n    .commingSoonBox > p{\n        font-size: 20px;\n        font-weight: 500;\n        text-align: center;\n        color: #717171;\n        text-align: center;\n        margin: 0;\n    }\n    .commingSoonBox > a{\n      text-decoration: none;\n    }\n    \n}\n\n\n@media screen and (max-width: 600px){\n\n     .commingSoonBox > h1{\n        font-size: 35px;\n        white-space: nowrap;\n        font-weight: 700;\n        text-align: center;\n        color: #000000;\n    }\n    .commingSoonBox > p{\n        font-size: 18px;\n        font-weight: 500;\n        text-align: center;\n        color: #717171;\n        text-align: center;\n        margin: 0;\n    }\n    .commingSoonBox > a{\n      text-decoration: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
